import {
  useEffect,
  useState,
} from 'react';
import Hls from 'hls.js';

const HLS_MIME_TYPE = [
  'application/x-mpegURL',
  'application/vnd.apple.mpegurl',
];

export default function useVideoSource(source, options) {
  const [attachMedia, setAttachMedia] = useState(null);
  const [loadSource, setLoadSource] = useState(null);
  const [loadedSource, setLoadedSource] = useState(null);
  const [mediaElement, setMediaElement] = useState(null);

  const [sourceContentType, setSourceContentType] = useState(null);

  useEffect(function () {
    if (source === null) return;

    fetch(source, {
      method: 'HEAD',
    })
      .then(response => {
        setSourceContentType(response.headers.get('Content-Type'));
      })
      .catch(error => console.error(error));
  }, [source]);

  useEffect(function() {
    if (source === null) return;
    if (sourceContentType === null) return;

    if (
      HLS_MIME_TYPE.some(mimeType => (
        mimeType.toLowerCase() === sourceContentType.toLowerCase()
      )) &&
      // hls.js is only supported on platforms that have Media Source Extensions
      // (MSE) enabled.
      Hls.isSupported()
    ) {
      const hls = new Hls({
        capLevelToPlayerSize: true,
        startLevel: -1,
        ...options,
      });

      hls.on(Hls.Events.MANIFEST_LOADING, function (event, data) {
        setLoadedSource(data.url);
      });

      hls.loadSource(source);

      setAttachMedia(() => (
        element => {
          hls.attachMedia(element);
          setMediaElement(element);
        }
      ));

      setLoadSource(() => source => hls.loadSource(source));

      return function() {
        hls.destroy();
      }
    }

    // If we do not need to treat HLS or the platform does not have MSE enabled,
    // we fallback to the built-in support.
    setAttachMedia(() => (
      element => {
        element.src = source;
        setLoadedSource(source); // @todo 2020-06-03
        setMediaElement(element);
      }
    ));

    setLoadSource(() => source => {
      if (mediaElement === null) return;
      mediaElement.src = source;
      setLoadedSource(source); // @todo 2020-06-03
    });

    return function() {}
  }, [source, options, mediaElement, sourceContentType]);

  return [attachMedia, loadSource, loadedSource];
}
